import { kaReducer, Table } from "ka-table";
import { loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import { useEffect, useState } from "react";


const VerifiedVerbalOrderListComponent = ({ verbalOrderList }) => {

    const tablePropsInit = {
        columns: [
            { key: "pat_name", title: "Patient Name" },
            { key: "pat_acct_num", title: "Account Number" },
            { key: "pat_dob", title: "DOB" },
            { key: "drg", title: "Drug Name" },
            { key: "provider", title: "Provider Name" },
            { key: "submitted_by", title: "Verbal Given By" },
        ],
        singleAction: loadData(),
        sortingMode: SortingMode.Single,
        rowKeyField: "fil_id",
        paging: {
            enabled: true,
            pageIndex: 0,
            pageSize: 10,
            position: PagingPosition.Bottom,
        },
    };

    const [tableProps, changeTableProps] = useState(tablePropsInit);

    let dispatch1 = async (action) => {
        changeTableProps((prevState) => kaReducer(prevState, action));
        if (action.type === ActionType.LoadData) {
        }
    };

    useEffect(() => {
        dispatch1(updateData(verbalOrderList));
    }, [])


    return (
        <div className="overflow-x-auto w-full pt-4">
            <Table
                {...tableProps}
                dispatch={dispatch1}
            />
        </div>
    )



}

export default VerifiedVerbalOrderListComponent;